import axios from 'axios'

import {
  setFormValues,
  setFilterValues,
  toggleFilterValues,
} from '../../../modules/mutations.js'

export const companiesGmbSearchStores = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    formValues: {
      stores: []
    },
    changeCheckBox: false,
    storeTotalCount: 0
  },
  mutations: {
    readStoresSuccess(state, payload) {
      state.data = payload.data
      state.storeTotalCount = payload.meta.total_count
      state.loading = false
    },
    prepareConnect(state) {
      state.loading = true
    },
    apiFailure(state) {
      state.loading = false
    },
    setFormValues(state, value) {
      setFormValues(state, value)
      state.changeCheckBox = !state.changeCheckBox
    },
    setFilterValues(state, payload) {
      setFilterValues(state, payload)
      state.changeCheckBox = !state.changeCheckBox
    },
    toggleFilterValues(state, payload) {
      toggleFilterValues(state, payload)
      state.changeCheckBox = !state.changeCheckBox
    },
    resetForm(state) {
      state.formValues = {
        stores: []
      }
    }
  },
  getters: {
    loading(state) {
      return state.loading
    },
    changeCheckBox(state) {
      return state.changeCheckBox
    },
    storeTotalCount(state) {
      return state.storeTotalCount
    },
    selectedStoresTotalCount(state) {
      return state.formValues.stores.length
    },
  },
  actions: {
    async readStores({ commit }, { companyUuid, formValues, excludeBusinessTypes, gmbCategoryIds, gmbMetadatas, onlyConnectedGmb = true, onlyConnectedDocomo = false, onlyConnectedYahooPlace = false }) {
      commit('prepareConnect')
      return axios
        .post('/api/companies/' + companyUuid + '/gmb/store_searches.json?', {
          search: {
            brand_ids: formValues?.brands,
            area_ids: formValues?.areas,
            franchisee_ids: formValues?.franchisees,
            user_company_ids: formValues?.user_companies,
            prefectures: formValues?.prefectures,
            original_tag_group_a_tag_ids: formValues?.original_tag_group_a,
            original_tag_group_b_tag_ids: formValues?.original_tag_group_b,
            original_tag_group_c_tag_ids: formValues?.original_tag_group_c,
            original_tag_group_d_tag_ids: formValues?.original_tag_group_d,
            original_tag_group_e_tag_ids: formValues?.original_tag_group_e,
            exclude_business_types: excludeBusinessTypes,
            gmb_category_ids: gmbCategoryIds,
            gmb_metadatas: gmbMetadatas,
            only_connected_gmb: onlyConnectedGmb,
            only_connected_docomo: onlyConnectedDocomo,
            only_connected_yahoo_place: onlyConnectedYahooPlace,
          }
        })
        .then(res => {
          commit('readStoresSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    setFormValues({ commit }, payload) {
      commit('setFormValues', payload)
    },
    resetForm({ commit }) {
      commit('resetForm')
    }
  },
}
